module.exports = __webpack_public_path__ + "img/C5.f815745d.png";